<template>
  <div class="router-transitions container-fluid flex-grow-1 container-p-y">
    <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      <div>Custom Icons</div>
      <b-btn variant="primary btn-round" class="d-block" @click="pointIconCreate">
        <span class="ion ion-md-add"></span>&nbsp; Create New Icon
      </b-btn>
    </h4>
    <b-card no-body>
      <div class="table-responsive" v-if="points.length">
        <b-table :items="points" :fields="fields" class="card-table">
          <template #cell(icon)="data">
            <img class="fpm-marker" :src="data.item.src" :style="{ width: data.item.width, height: data.item.height }" />
          </template>
          <template #cell(actions)="data">
            <b-btn variant="default btn-sm icon-btn md-btn-flat" title="Edit" @click="edit(data.item)"
              ><i class="ion ion-md-create"></i
            ></b-btn>
          </template>
        </b-table>
      </div>
      <div v-else class="my-5 text-center text-big">
        You don't have custom icons
        <br />
        <b-btn variant="primary btn-round" class="my-3" @click="pointIconCreate">
          <span class="ion ion-md-add"></span>&nbsp; Create New
        </b-btn>
      </div>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Id, { isLocalId } from '@/utils/Id'
import { getIconUrl } from '@/components/leaflet/Icon'

export default {
  name: 'PointIcons',
  data: () => ({
    fields: [{ key: 'icon', class: 'icon-column' }, { key: 'name' }, { key: 'actions', label: ' ', tdClass: 'text-right mr-3 text-nowrap' }]
  }),
  computed: {
    ...mapGetters('pointIcon', ['pointIcons']),
    points() {
      return this.pointIcons
        .filter((u) => !isLocalId(u.id) && u.id > 100)
        .map((v) => ({
          ...v,
          src: getIconUrl(v.id, v.file_updated_at),
          width: `${v.width}px`,
          height: `${v.height}px`
        }))
    }
  },
  methods: {
    ...mapActions('pointIcon', ['pointIconsLoad']),
    edit(pointIcon) {
      this.$router.push({ name: 'point-icon-edit', params: { pointIconId: pointIcon.id } })
    },
    pointIconCreate() {
      this.edit({ id: Id() })
    },
    load() {
      this.pointIconsLoad({ params: { sort: 'name' } })
    }
  },
  created() {
    this.load()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === 'point-icons') {
      this.load()
    }
    next()
  }
}
</script>

<style>
.icon-column {
  width: 60px;
  text-align: center;
}
</style>
